"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateReleaseInfo = generateReleaseInfo;
exports.verifyLicense = verifyLicense;
var _base = require("../encoding/base64");
var _md = require("../encoding/md5");
var _licenseStatus = require("../utils/licenseStatus");
var _plan = require("../utils/plan");
var _licenseModel = require("../utils/licenseModel");
var getDefaultReleaseDate = function() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function generateReleaseInfo() {
    var releaseDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getDefaultReleaseDate();
    return (0, _base.base64Encode)(releaseDate.getTime().toString());
}
function isPlanScopeSufficient(packageName, planScope) {
    var acceptedScopes;
    if (packageName.includes('-pro')) {
        acceptedScopes = [
            'pro',
            'premium'
        ];
    } else if (packageName.includes('-premium')) {
        acceptedScopes = [
            'premium'
        ];
    } else {
        acceptedScopes = [];
    }
    return acceptedScopes.includes(planScope);
}
var expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
var PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN = [
    'x-data-grid-pro',
    'x-date-pickers-pro'
];
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ var decodeLicenseVersion1 = function(license) {
    var expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match(expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) {
            expiryTimestamp = null;
        }
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        planScope: 'pro',
        licenseModel: 'perpetual',
        expiryTimestamp: expiryTimestamp,
        planVersion: 'initial'
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${planScope},LM=${licenseModel},PV=${planVersion},KV=2`;
 */ var decodeLicenseVersion2 = function(license) {
    var licenseInfo = {
        planScope: null,
        licenseModel: null,
        expiryTimestamp: null,
        planVersion: 'initial'
    };
    license.split(',').map(function(token) {
        return token.split('=');
    }).filter(function(el) {
        return el.length === 2;
    }).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (key === 'S') {
            licenseInfo.planScope = value;
        }
        if (key === 'LM') {
            licenseInfo.licenseModel = value;
        }
        if (key === 'E') {
            var expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) {
                licenseInfo.expiryTimestamp = expiryTimestamp;
            }
        }
        if (key === 'PV') {
            licenseInfo.planVersion = value;
        }
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ var decodeLicense = function(encodedLicense) {
    var license = (0, _base.base64Decode)(encodedLicense);
    if (license.includes('KEYVERSION=1')) {
        return decodeLicenseVersion1(license);
    }
    if (license.includes('KV=2')) {
        return decodeLicenseVersion2(license);
    }
    return null;
};
function verifyLicense(param) {
    var releaseInfo = param.releaseInfo, licenseKey = param.licenseKey, packageName = param.packageName;
    if (!releaseInfo) {
        throw new Error('MUI X: The release information is missing. Not able to validate license.');
    }
    if (!licenseKey) {
        return {
            status: _licenseStatus.LICENSE_STATUS.NotFound
        };
    }
    var hash = licenseKey.substr(0, 32);
    var encoded = licenseKey.substr(32);
    if (hash !== (0, _md.md5)(encoded)) {
        return {
            status: _licenseStatus.LICENSE_STATUS.Invalid
        };
    }
    var license = decodeLicense(encoded);
    if (license == null) {
        console.error('MUI X: Error checking license. Key version not found!');
        return {
            status: _licenseStatus.LICENSE_STATUS.Invalid
        };
    }
    if (license.licenseModel == null || !_licenseModel.LICENSE_MODELS.includes(license.licenseModel)) {
        console.error('MUI X: Error checking license. Licensing model not found or invalid!');
        return {
            status: _licenseStatus.LICENSE_STATUS.Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error('MUI X: Error checking license. Expiry timestamp not found or invalid!');
        return {
            status: _licenseStatus.LICENSE_STATUS.Invalid
        };
    }
    if (license.licenseModel === 'perpetual' || process.env.NODE_ENV === 'production') {
        var pkgTimestamp = parseInt((0, _base.base64Decode)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) {
            throw new Error('MUI X: The release information is invalid. Not able to validate license.');
        }
        if (license.expiryTimestamp < pkgTimestamp) {
            return {
                status: _licenseStatus.LICENSE_STATUS.ExpiredVersion
            };
        }
    } else if (license.licenseModel === 'subscription' || license.licenseModel === 'annual') {
        if (new Date().getTime() > license.expiryTimestamp) {
            if (// 30 days grace
            new Date().getTime() < license.expiryTimestamp + 1000 * 3600 * 24 * 30 || process.env.NODE_ENV !== 'development') {
                return {
                    status: _licenseStatus.LICENSE_STATUS.ExpiredAnnualGrace,
                    meta: {
                        expiryTimestamp: license.expiryTimestamp,
                        licenseKey: licenseKey
                    }
                };
            }
            return {
                status: _licenseStatus.LICENSE_STATUS.ExpiredAnnual,
                meta: {
                    expiryTimestamp: license.expiryTimestamp,
                    licenseKey: licenseKey
                }
            };
        }
    }
    if (license.planScope == null || !_plan.PLAN_SCOPES.includes(license.planScope)) {
        console.error('MUI X: Error checking license. planScope not found or invalid!');
        return {
            status: _licenseStatus.LICENSE_STATUS.Invalid
        };
    }
    if (!isPlanScopeSufficient(packageName, license.planScope)) {
        return {
            status: _licenseStatus.LICENSE_STATUS.OutOfScope
        };
    }
    // 'charts-pro' or 'tree-view-pro' can only be used with a newer Pro license
    if (license.planVersion === 'initial' && license.planScope === 'pro' && !PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN.includes(packageName)) {
        return {
            status: _licenseStatus.LICENSE_STATUS.NotAvailableInInitialProPlan
        };
    }
    return {
        status: _licenseStatus.LICENSE_STATUS.Valid
    };
}
